export function mapToObj<T>(map: Map<string, T>): any {
    return [...map.entries()].reduce((obj, [key, value]) => {
        // @ts-ignore
        obj[key] = value;
        return obj;
    }, {});
}
